import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuthToken } from "../../App/State/Hooks/authHooks";
import { useManagementClients } from "../../App/Queries/ClientQueries";

export default function JobsRedirect() {
  const token = useAuthToken();
  const navigate = useNavigate();
  const { data: clients, isLoading } = useManagementClients();
  const apiUrl = `${import.meta.env.VITE_BACKEND_API ?? "https://localhost:44392"}/jobs?access_token=${token}`;
  useEffect(() => {
    if (!isLoading) {
      if (!clients || clients.length <= 0) {
        navigate("/");
      } else if (apiUrl && token) {
        window.location.href = apiUrl;
      }
    }
  }, [clients, isLoading, navigate, apiUrl, token]);

  return <></>;
}
